import { VisitSummaryResponse } from '../types/visit-summary.types';
import { client } from './client';

export const getVisitSummary = async (visitId: number | string): Promise<VisitSummaryResponse> => {
  const nonce = window.cabinetVars?.nonce || window.customApiVars?.nonce || '';
  
  const res = await client.get(`/users/me/visit/${visitId}/summary`, {
    headers: {
      'X-WP-Nonce': nonce,
    },
  });
  
  return res.data;
};
